import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { requestClassificationInterface, urgencyInterface } from 'src/app/util/interfaces/requestClassification';
import { environment } from 'src/environments/environment';

export interface searchDefaultUrgencyDTO {
	idTopic: string;
	idSolutionArea: string;
	scope: string;
	defaultUrgency: string;
	category: string;
	topic: string;
}

@Injectable({
	providedIn: 'root',
})
export class DefaultUrgencyService {
	private getSolutionAreaUrl = environment.baseApiUrl + 'solutionarea/customer/{idCustomer}';
	private getScopeUrl = environment.baseApiUrl + 'scope/customer/{idCustomer}';
	private getCategoryUrl = environment.baseApiUrl + 'category/customer/{idCustomer}';
	private getTopicUrl = environment.baseApiUrl + 'topic/customer/{idCustomer}';

	private defaultUrgencyUrl = environment.baseApiUrl + 'register/customer/defaultUrgency';
	private availableUrgenciesUrl = environment.baseApiUrl + 'register/customer/defaultUrgency/available';

	headers = new HttpHeaders({
		Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
		'Content-Type': 'application/json;charset=UTF-8',
	});

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	searchClassifications(classification: requestClassificationInterface): Observable<searchDefaultUrgencyDTO[]> {
		return this.http.get<searchDefaultUrgencyDTO[]>(this.defaultUrgencyUrl, {
			headers: this.headers,
			params: {
				solution_area: classification.solutionArea[0] ? classification.solutionArea[0].id : '',
				scope: classification.scope[0] ? classification.scope[0].id : '',
				category: classification.category[0] ? classification.category[0].id : '',
				topic: classification.topic[0] ? classification.topic[0].id : '',
			},
		});
	}

	getAvailableUrgencies(idCustomer: string): Observable<urgencyInterface[]> {
		return this.http.get<urgencyInterface[]>(this.availableUrgenciesUrl, { headers: this.headers, params: { idCustomer: idCustomer } });
	}

	saveDefaultUrgency(defaultUrgencyArray: searchDefaultUrgencyDTO[]): Observable<any> {
		return this.http.put<any>(this.defaultUrgencyUrl, defaultUrgencyArray, { headers: this.headers });
	}
}
